/* eslint-disable */
import "../inactivity_timeout";
import React from "react";
import { createRoot } from 'react-dom/client';
import { createPortal } from 'react-dom';
import { Provider, ErrorBoundary } from '@rollbar/react';
import Rollbar from "rollbar";
import TopNavbar from "../src/TopNavbar";
import { mountReportsNavbar } from '../src/reports/utils/Navbar';
import { reactourSteps, reactourStyles } from '../src/ReactourHelper';
import { TourProvider } from '@reactour/tour';
import { ToastContainer } from 'react-toastify';
import ReportContainerWrapper from '../src/reports/ReportContainerWrapper';
import MonthlyReportContainer from '../src/reports/monthly/MonthlyReportContainer';
import DashboardViewEditorPage from '../src/reports/DashboardViewEditorPage';
import EditChartOfAccounts from '../src/naics_chart_of_accounts/EditChartOfAccounts';
import ManageFirm from "../src/manage_firm/ManageFirm";
import EditFdu from '../src/financial_data_uploads/EditFdu';
import EditSurveyFormat from '../src/naics_survey_formats/EditSurveyFormat';
import IndustryReportContainer from '../src/reports/IndustryReport/IndustryReportContainer';
import IntacctLogin from '../src/IntacctLogin';
import ManageClientsTable from '../src/clients/ManageClientsTable';
import NSCHBCReportContainer from '../src/reports/NSCHBCReport/NSCHBCReportContainer';
import NewUserForm from "../src/NewUserForm";
import Mapper from '../src/mapper/Mapper';
import FduMappingStats from '../src/admin/OpsView/FduMappingStats';
import OpsContainer from '../src/admin/OpsView/OpsContainer';
import CompanyCreated from '../src/admin/OpsView/CompanyCreated';
import FirmReportContainer from "../src/reports/FirmReport/FirmReportContainer";
import PracticeReport from '../src/reports/PracticeReport/PracticeReport';
import QualifiedCalcsInfo from '../src/admin/OpsView/QualifiedCalcsInfo';
import RecentFdusInfo from '../src/admin/OpsView/RecentFdusInfo';
import RecurlyPlans from '../src/RecurlyPlans';
import SignUp from '../src/SignUp';
import UserDashboard from '../src/users/UserDashboard';
import Workflow from "../src/workflows/Workflow";
import CeReportContainer from "../src/reports/CeReportContainer";
import PracticeReportContainer from "../src/reports/PracticeReport/PracticeReportContainer";
if (!window.errorLog) window.errorLog = [];

// same configuration you would create for the Rollbar.js SDK
const rollbarConfig = {
  accessToken: window.rollbarAccessToken,
  hostSafeList: [/\.?peerviewdata\.com$/, /\.?peerviewdev\.com$/], // only work in staging and production with all subdomains
  captureUncaught: true,
  captureUnhandledRejections: true,
  checkIgnore: function(isUncaught, args, payload) {
    if (args && args.length === 3) {
      if (args[1]?.stack) {
        let stackString = args[1].stack.slice(0, 200)
        if (window.errorLog.includes(stackString)) {
          return true
        } else {
          window.errorLog.push(stackString)
          return false
        }
      }
    }
    return false
  },
  environment: 'production',
  payload: {
    person: {
      id: window.data?.user_id,
    }
  }
};

const rollbar = new Rollbar(rollbarConfig);

document.addEventListener('DOMContentLoaded', () => {
  const topNavTarget = document.getElementById('top-navbar-target');

  if (topNavTarget) {
    const navbar = window.navbar.navbar;
    const navRoot = createRoot(topNavTarget)
    const isAdminView = document.body.getAttribute('data-layout') === 'admin';

    navRoot.render(
      <Provider config={rollbar}>
        <ErrorBoundary>
          <TopNavbar {...navbar} isAdminView={isAdminView} />
        </ErrorBoundary>
      </Provider>
    )
  }

  const targetReports = document.getElementById('report-target');
  if (targetReports) {
    const root = createRoot(targetReports);
    let page = window.data.page;
    const tourSteps = reactourSteps(page, window.data.tour_data);
    const numberOfTourSteps = tourSteps ? tourSteps.length : 0;
    const tourStyles = reactourStyles(page);
    const navbar = window.navbar.navbar;

    root.render(
      <Provider config={rollbar}>
        <ErrorBoundary>
          <TourProvider
            scrollSmooth={true}
            steps={tourSteps}
            styles={tourStyles}
            onClickMask={({ currentStep, setCurrentStep, setIsOpen }) => {
              if (currentStep < numberOfTourSteps - 1) {
                let nextStep = currentStep + 1
                setCurrentStep(nextStep)
              } else {
                setIsOpen(false)
                setCurrentStep(0)
              }
            }}
          >
            <ReportContainerWrapper {...window.data} planType={navbar.plan_type} planAccess={navbar.plan_type_access} />
          </TourProvider>
        </ErrorBoundary>
      </Provider>
    );
  }

  const targetMonthlyReport = document.getElementById('monthly-report-target')
  if (targetMonthlyReport) {
    const root = createRoot(targetMonthlyReport);
    let tourData = window.data.tour_data;
    const tourSteps = reactourSteps('forecast', tourData);
    const numberOfTourSteps = tourSteps.length;
    const tourStyles = reactourStyles('forecast');
    const navbar = window.navbar.navbar;

    let tourTaken = tourData.tour_taken
    const endTour = () => {
      if (!tourTaken) {
        fetch(`/api/v1/tour/end_tour/${tourData.tracker_id}`, {
          method: "POST",
          headers: {
            'X-CSRF-Token': window.token,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ page: window.data.page })
        });
      }
    };

    root.render(
      <Provider config={rollbar}>
        <ErrorBoundary>
          <TourProvider
            scrollSmooth={true}
            steps={tourSteps}
            styles={tourStyles}
            onClickMask={({ currentStep, setCurrentStep, setIsOpen }) => {
              if (currentStep === 0 && !tourTaken) {
                endTour()
              }
              if (currentStep < numberOfTourSteps - 1) {
                let nextStep = currentStep + 1
                setCurrentStep(nextStep)
              } else {
                setIsOpen(false)
                setCurrentStep(0)
              }
            }}
          >
            <MonthlyReportContainer {...window.data} />
          </TourProvider>
        </ErrorBoundary>
      </Provider>
    );
  }

  const targetDashboardView = document.getElementById('dashboard-view-target');
  if (targetDashboardView) {
    const root = createRoot(targetDashboardView);
    let tourData = window.data.tour_data;
    const tourSteps = reactourSteps('custom_report_builder', tourData);
    const numberOfTourSteps = tourSteps.length;
    const tourStyles = reactourStyles('custom_report_builder');

    root.render(
      <Provider config={rollbar}>
        <ErrorBoundary> 
          <TourProvider
            scrollSmooth={true}
            steps={tourSteps}
            styles={tourStyles}
            onClickMask={({ currentStep, setCurrentStep, setIsOpen }) => {
              if (currentStep < numberOfTourSteps - 1) {
                let nextStep = currentStep + 1
                setCurrentStep(nextStep)
              } else {
                setIsOpen(false)
                setCurrentStep(0)
              }
            }}
          >
            <DashboardViewEditorPage {...window.data} />
          </TourProvider>
        </ErrorBoundary>
      </Provider>
    );
  }

  const targetCOA = document.getElementById('chart_of_account_target');
  if (targetCOA) {
    const root = createRoot(targetCOA);
    root.render(
      <Provider config={rollbar}>
        <ErrorBoundary>
          <EditChartOfAccounts {...window.data} />
        </ErrorBoundary>
      </Provider>
    );
  }

  const targetIntacctLogin = document.getElementById('intacct_login_target');
  if (targetIntacctLogin) {
    const root = createRoot(targetIntacctLogin);
    root.render(
      <Provider config={rollbar}>
        <ErrorBoundary>      
          <IntacctLogin {...window.info} />
        </ErrorBoundary>
      </Provider>
    );
  }

  const targetManageFirm = document.getElementById('edit-company-form')
  if (targetManageFirm) {
    const root = createRoot(targetManageFirm);
    root.render(
      <Provider config={rollbar}>
        <ErrorBoundary>      
          <ManageFirm {...window.data} />
        </ErrorBoundary>
      </Provider>
    );
  }

  const targetEditFDU = document.getElementById('edit_fdu_target')
  if (targetEditFDU) {
    const root = createRoot(targetEditFDU);
    root.render(
      <Provider config={rollbar}>
        <ErrorBoundary>      
          <EditFdu {...window.data} />
        </ErrorBoundary>
      </Provider>
    );
  }

  const targetEditSurveyFormat = document.getElementById('survey_format_target');
  if (targetEditSurveyFormat) {
    const root = createRoot(targetEditSurveyFormat);
    root.render(
      <Provider config={rollbar}>
        <ErrorBoundary>      
          <EditSurveyFormat {...window.data} />
        </ErrorBoundary>
      </Provider>
    );
  }

  const targetIndustry = document.getElementById('industry-report-target');
  if (targetIndustry) {
    const root = createRoot(targetIndustry);
    const tourSteps = reactourSteps('industry', window.data);
    const numberOfTourSteps = tourSteps.length;
    const tourStyles = reactourStyles('industry');

    root.render(
      <Provider config={rollbar}>
        <ErrorBoundary>
          <TourProvider
            scrollSmooth={true}
            steps={tourSteps}
            styles={tourStyles}
            onClickMask={({ currentStep, setCurrentStep, setIsOpen }) => {
              if (currentStep < numberOfTourSteps - 1) {
                let nextStep = currentStep + 1
                setCurrentStep(nextStep)
              } else {
                setIsOpen(false)
                setCurrentStep(0)
              }
            }}
          >
            <IndustryReportContainer {...window.data} />
          </TourProvider>
        </ErrorBoundary>
      </Provider>
    );
  }

  const targetMC = document.getElementById('client-container-target');
  if (targetMC) {
    const notificationTarget = document.getElementById('notification-container-target')
    const notiRoot = createRoot(notificationTarget)
    notiRoot.render(
      <ToastContainer
        position='top-right'
        autoClose={false}
        closeButton={true}
        closeOnClick={false}
      />
    )

    const root = createRoot(targetMC);
    const navbar_info = window.navbar.navbar;
    const nschbc = JSON.parse(targetMC.getAttribute('nschbc'));
    const ce_groups = JSON.parse(targetMC.getAttribute('ce_groups'));
    const filter_options_obj = JSON.parse(targetMC.getAttribute('filter_options_obj'));
    const user_mc_views = JSON.parse(targetMC.getAttribute('user_mc_views'));
    const naics_list = JSON.parse(targetMC.getAttribute('naics_list'));
    const qbo_notifications = JSON.parse(targetMC.getAttribute('qbo_notifications'));
    const users = JSON.parse(targetMC.getAttribute('users'));
    let tourData = JSON.parse(targetMC.getAttribute('tour_data'));
    const tourSteps = reactourSteps('manageClients', tourData);
    const numberOfTourSteps = tourSteps.length;
    const tourStyles = reactourStyles('manageClients');
    const xero_connect_url = JSON.parse(targetMC.getAttribute('xero_connect_url'));
    const plan_access = JSON.parse(targetMC.getAttribute('plan_access'));
    const plan_type = targetMC.getAttribute('plan_type');
    const user_notifications = JSON.parse(targetMC.getAttribute('user_notifications'));

    let tourTaken = tourData.tour_taken
    const endTour = () => {
      if (!tourTaken) {
        fetch(`/api/v1/tour/end_tour/${tourData.tracker_id}`, {
          method: "POST"
        });
      }
    };

    root.render(
      <Provider config={rollbar}>
        <ErrorBoundary>
          <TourProvider
            scrollSmooth={true}
            steps={tourSteps}
            styles={tourStyles}
            onClickMask={({ currentStep, setCurrentStep, setIsOpen }) => {
              if (currentStep < numberOfTourSteps - 1) {
                let nextStep = currentStep + 1
                setCurrentStep(nextStep)
              } else {
                endTour()
                setIsOpen(false)
                setCurrentStep(0)
              }
            }}
          >
            <ManageClientsTable nschbc={nschbc} ce_groups={ce_groups} filterOptionsObj={filter_options_obj} navBarInfo={navbar_info} naicsList={naics_list} user_mc_views={user_mc_views} qbo_notifications={qbo_notifications} users={users} tourData={tourData} xero_connect_url={xero_connect_url} plan_access={plan_access} plan_type={plan_type} user_notifications={user_notifications} />
          </TourProvider>
        </ErrorBoundary>
      </Provider>
    );
  }

  const targetMapper = document.getElementById('mapper-target');
  if (targetMapper) {
    const root = createRoot(targetMapper);
    let tourData = window.data.tour_data;
    const tourSteps = reactourSteps('map file', tourData);
    const numberOfTourSteps = tourSteps.length;
    const tourStyles = reactourStyles('map file');

    let tourTaken = tourData.tour_taken
    const endTour = () => {
      if (!tourTaken) {
        fetch(`/api/v1/tour/end_tour/${tourData.tracker_id}`, {
          method: "POST"
        });
      }
    };

    root.render(
      <Provider config={rollbar}>
        <ErrorBoundary>
          <TourProvider
            scrollSmooth={true}
            steps={tourSteps}
            styles={tourStyles}
            onClickMask={({ currentStep, setCurrentStep, setIsOpen }) => {
              if (currentStep < numberOfTourSteps - 1) {
                let nextStep = currentStep + 1
                setCurrentStep(nextStep)
              } else {
                endTour()
                setIsOpen(false)
                setCurrentStep(0)
              }
            }}
          >
            <Mapper {...window.data} tourData={tourData} />
          </TourProvider>
        </ErrorBoundary>
      </Provider>
    );
  }

  const targetNSCHBC = document.getElementById('nschbc-report-target');
  if (targetNSCHBC) {
    const root = createRoot(targetNSCHBC);

    root.render (
      <Provider config={rollbar}>
        <ErrorBoundary>
          <NSCHBCReportContainer {...window.data} />
        </ErrorBoundary>
       </Provider>
    )
  }

  // no append_javascript_tag
  const targetOpsUserStats = document.getElementById('admin-ops-view-user-stats')
  if (targetOpsUserStats) {
    const root = createRoot(targetOpsUserStats);
    root.render(
      <Provider config={rollbar}>
        <ErrorBoundary>
          <OpsContainer {...window.data} />
        </ErrorBoundary>
      </Provider>
    );
  }

  // no append_javascript_tag
  const targetOpsMappingStats = document.getElementById('admin-ops-fdu-mapping-stats')
  if (targetOpsMappingStats) {
    const root = createRoot(targetOpsMappingStats);
    root.render(
      <Provider config={rollbar}>
        <ErrorBoundary>
          <FduMappingStats {...window.data} />
        </ErrorBoundary>
      </Provider>
    );
  }

  // no append_javascript_tag
  const targetOpsCompanyCreated = document.getElementById('admin-ops-company-created')
  if (targetOpsCompanyCreated) {
    const root = createRoot(targetOpsCompanyCreated);
    root.render(
      <Provider config={rollbar}>
        <ErrorBoundary>
          <CompanyCreated {...window.data} />
        </ErrorBoundary>
      </Provider>
    );
  }

  const targetFirm = document.getElementById('firm-target')
  if (targetFirm) {
    const notificationTarget = document.getElementById('notification-container-target')

    const root = createRoot(targetFirm);
    const tourSteps = reactourSteps('practice', window.data);
    const numberOfTourSteps = tourSteps.length;
    const tourStyles = reactourStyles('practice');

    root.render(
      <Provider config={rollbar}>
        <ErrorBoundary>
          <TourProvider
            scrollSmooth={true}
            steps={tourSteps}
            styles={tourStyles}
            onClickMask={({ currentStep, setCurrentStep, setIsOpen }) => {
              if (currentStep < numberOfTourSteps - 1) {
                let nextStep = currentStep + 1
                setCurrentStep(nextStep)
              } else {
                setIsOpen(false)
                setCurrentStep(0)
              }
            }}
          >
            {notificationTarget && createPortal(
              <ToastContainer
                position='top-right'
                autoClose={false}
                closeButton={true}
                closeOnClick={false}
              />,
              notificationTarget
            )}

            <FirmReportContainer {...window.data} />
          </TourProvider>
        </ErrorBoundary>
      </Provider>
    );
  }

  const targetPractice = document.getElementById('practice-target')
  if (targetPractice) {
    const root = createRoot(targetPractice);
    const tourSteps = reactourSteps('practice', window.data);
    const numberOfTourSteps = tourSteps.length;
    const tourStyles = reactourStyles('practice');

    root.render(
      <Provider config={rollbar}>
        <ErrorBoundary>
          <TourProvider
            scrollSmooth={true}
            steps={tourSteps}
            styles={tourStyles}
            onClickMask={({ currentStep, setCurrentStep, setIsOpen }) => {
              if (currentStep < numberOfTourSteps - 1) {
                let nextStep = currentStep + 1
                setCurrentStep(nextStep)
              } else {
                setIsOpen(false)
                setCurrentStep(0)
              }
            }}
          >
            <PracticeReportContainer {...window.data} />
          </TourProvider>
        </ErrorBoundary>
      </Provider>
    );
  }

  // no append_javascript_tag
  const targetQualifedCalcs = document.getElementById('qualified_calcs_info_target');
  if (targetQualifedCalcs) {
    const root = createRoot(targetQualifedCalcs);
    root.render(
      <Provider config={rollbar}>
        <ErrorBoundary>
          <QualifiedCalcsInfo {...window.data} />
        </ErrorBoundary>
      </Provider>
    );
  }

  // no append_javascript_tag
  const targetRecentFDUs = document.getElementById('recent_fdus_info_target');
  if (targetRecentFDUs) {
    const root = createRoot(targetRecentFDUs);
    root.render(
      <Provider config={rollbar}>
        <ErrorBoundary>
          <RecentFdusInfo {...window.data} />
        </ErrorBoundary>
      </Provider>
    );
  }

  const targetSubscriptions = document.getElementById('subscriptions-target')
  if (targetSubscriptions) {
    const root = createRoot(targetSubscriptions);
    let planType = window.navbar.navbar.plan_type
    let userType = window.navbar.navbar.user_type
    root.render(
      <Provider config={rollbar}>
        <ErrorBoundary>         
          <RecurlyPlans subData={window.data.subData} futureSubData={window.data.futureSubData} planType={planType} userType={userType} />
        </ErrorBoundary>
      </Provider>
    );
  }

  const targetDemoSignUp = document.getElementById('demo_signup_target');
  if (targetDemoSignUp) {
    const root = createRoot(targetDemoSignUp);
    root.render(
      <Provider config={rollbar}>
        <ErrorBoundary>       
          <SignUp {...window.data} />
        </ErrorBoundary>
      </Provider>
    );
  }

  const targetFreeSignUp = document.getElementById('freemium_signup_target');
  if (targetFreeSignUp) {
    const root = createRoot(targetFreeSignUp);
    root.render(
      <Provider config={rollbar}>
        <ErrorBoundary>       
          <SignUp {...window.data} />
        </ErrorBoundary>
      </Provider>
    );
  }

  const newUserForm = document.getElementById('new-user-form')
  if (newUserForm) {
    const root = createRoot(newUserForm);
    root.render(
      <Provider config={rollbar}>
        <ErrorBoundary>       
          <NewUserForm {...window.data} using_navbar={false} />
        </ErrorBoundary>
      </Provider>
    );
  }

  const targetUserDash = document.getElementById('user-dashboard-target');
  if (targetUserDash) {
    const root = createRoot(targetUserDash);
    root.render(
      <Provider config={rollbar}>
        <ErrorBoundary>       
          <UserDashboard {...window.data} />
        </ErrorBoundary>
      </Provider>
    );
  }

  const targetWorkflow = document.getElementById('workflow-target');
  if (targetWorkflow) {
    const root = createRoot(targetWorkflow);
    root.render(
      <Provider config={rollbar}>
        <ErrorBoundary>       
          <Workflow {...window.data} />
        </ErrorBoundary>
      </Provider>
    );
  }

  const targetCeReports = document.getElementById('ce-report-target');
  if (targetCeReports) {
    const root = createRoot(targetCeReports);
    let page = window.data.page;
    const navbar = window.navbar.navbar;

    root.render(
      <Provider config={rollbar}>
        <ErrorBoundary>
          <CeReportContainer {...window.data} planType={navbar.plan_type} planAccess={navbar.plan_type_access} />
        </ErrorBoundary>
      </Provider>
    );
  }
});